import SmartGallery from 'react-smart-gallery'
import React, { Component } from 'react'
import Lightbox from 'react-images'

class Gallery extends Component {
	constructor(){
    super()
    this.state = { currentImage: 0 }

    this.closeLightbox = this.closeLightbox.bind(this)
    this.openLightbox = this.openLightbox.bind(this)
    this.gotoNext = this.gotoNext.bind(this)
    this.gotoPrevious = this.gotoPrevious.bind(this)
  }

	openLightbox(event, obj, index) {
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
		})
	}

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
		})
	}

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
		})
	}

	gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
		})
	}

	render () {
		return (
			<div>
				<SmartGallery images={this.props.images.map(item => item.src)} height={this.props.height} width={'100%'} onImageSelect={this.openLightbox}/>
				<Lightbox images={this.props.images}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
        />
			</div>
		)
	}
}

export default Gallery
